/* Smarket search core — pure matching/ranking, no DOM. ES5 so it runs in old
   mobile browsers untouched. Loaded in the theme (window.SMKSearchCore) and in
   Node for tests (module.exports). Spec: docs/specs/2026-09-08-theme-native-search-design.md §4.2 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SMKSearchCore = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Small synonym table. Keys and values are already normalised (see norm()).
  var SYN = {
    hdd: ['harddrive', 'harddisk'],
    harddrive: ['hdd'],
    harddisk: ['hdd'],
    wifi: ['wireless'],
    wireless: ['wifi'],
    recorder: ['nvr'],
    cam: ['camera'],
    cams: ['camera']
  };
  var KIT_RE = /\bkit\b|\d+\s*x\s*\d|\d+\s*ch\b|channel/i;
  var WANTS_KIT_RE = /kit|channel|\bch\b|\d+\s*x/i;

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[-\/().,_'’‑–\s]+/g, '');
  }
  function splitWords(s) {
    var out = [], parts = String(s == null ? '' : s).toLowerCase().split(/[\s\/(),.;:|]+/);
    for (var i = 0; i < parts.length; i++) { var w = norm(parts[i]); if (w) out.push(w); }
    return out;
  }
  function stem(f) {
    var s = f.replace(/ies$/, 'y').replace(/s$/, '');
    return s.length >= 2 ? s : f;
  }
  function lev1(a, b) {
    var la = a.length, lb = b.length;
    if (a === b || Math.abs(la - lb) > 1) return false;
    var i = 0, j = 0, edits = 0;
    while (i < la && j < lb) {
      if (a.charAt(i) === b.charAt(j)) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (la > lb) i++; else if (la < lb) j++; else { i++; j++; }
    }
    return edits + (la - i) + (lb - j) <= 1;
  }
  function uniq(arr) { var o = {}, out = []; for (var i = 0; i < arr.length; i++) if (!o[arr[i]]) { o[arr[i]] = 1; out.push(arr[i]); } return out; }
  function anyStarts(list, f) { for (var i = 0; i < list.length; i++) if (list[i].indexOf(f) === 0) return true; return false; }
  function anyIncludes(list, f) { for (var i = 0; i < list.length; i++) if (list[i].indexOf(f) !== -1) return true; return false; }
  function anyEquals(list, f) { for (var i = 0; i < list.length; i++) if (list[i] === f) return true; return false; }

  // Score tiers from the spec table.
  function fragScore(it, f) {
    if (anyEquals(it.ns, f)) return 100;
    if (anyStarts(it.ns, f)) return 80;
    if (anyIncludes(it.ns, f)) return 60;
    if (anyStarts(it.words, f)) return 40;
    if (it.nt.indexOf(f) !== -1) return 30;
    if (it.nv.indexOf(f) !== -1 || it.ny.indexOf(f) !== -1) return 20;
    if (anyIncludes(it.tags, f)) return 15;
    if (anyStarts(it.dw, f) || (descSubstringOk(f) && anyIncludes(it.dw, f))) return 10;
    return 0;
  }
  // Description words match by prefix; substring only for fragments long enough
  // (≥5) or model-like (≥4 with a digit) so short words don't fire on noise.
  function descSubstringOk(f) { return f.length >= 5 || (f.length >= 4 && /\d/.test(f)); }

  // Price buckets (cents) mirroring the collection sidebar: $0–1,000 · $1,000–2,000 · $2,000+
  var PRICE_BUCKETS = ['0-100000', '100000-200000', '200000-'];
  function priceBucket(p) { p = +p || 0; return p < 100000 ? PRICE_BUCKETS[0] : p < 200000 ? PRICE_BUCKETS[1] : PRICE_BUCKETS[2]; }
  // sel = { resolution: ['4K (8MP)'], nightvision: [...] } — every selected group must match one of its values.
  function matchesFacets(have, sel) {
    for (var key in sel) if (Object.prototype.hasOwnProperty.call(sel, key)) {
      var want = sel[key]; if (!want || !want.length) continue;
      var got = have[key] || [], hit = false;
      for (var i = 0; i < got.length && !hit; i++) if (want.indexOf(got[i]) !== -1) hit = true;
      if (!hit) return false;
    }
    return true;
  }

  // Query suggestions for the dropdown: popular terms whose words start with the typed
  // fragments (then plain substring), followed by full SKUs from the matched products.
  // popular: string[] in popularity order; items: query() results (need .s). Max `limit` entries.
  function suggest(term, popular, items, limit) {
    limit = limit || 5;
    var frags = splitWords(term), q = norm(term), out = [], seen = {}, i, j;
    if (!q || q.length < 2) return out;
    function add(text, kind) { var k = norm(text); if (!k || k === q || seen[k] || out.length >= limit) return; seen[k] = 1; out.push({ text: text, kind: kind }); }
    var starts = [], contains = [];
    for (i = 0; i < (popular || []).length; i++) {
      var p = popular[i], words = splitWords(p), np = norm(p), ok = true, allStart = true;
      for (j = 0; j < frags.length; j++) {
        var f = frags[j], hit = false, st = false;
        for (var w = 0; w < words.length; w++) { if (words[w].indexOf(f) === 0) { hit = true; st = true; break; } if (words[w].indexOf(f) !== -1) hit = true; }
        if (!hit && np.indexOf(f) === -1) { ok = false; break; }
        if (!st) allStart = false;
      }
      if (!ok) continue;
      (allStart ? starts : contains).push(p);
    }
    var maxPopular = Math.max(2, limit - 2);
    for (i = 0; i < starts.length && out.length < maxPopular; i++) add(starts[i], 'popular');
    for (i = 0; i < contains.length && out.length < maxPopular; i++) add(contains[i], 'popular');
    for (i = 0; i < (items || []).length && out.length < limit; i++) {
      var skus = items[i].s || [];
      for (j = 0; j < skus.length; j++) if (norm(skus[j]).indexOf(q) !== -1) { add(skus[j], 'sku'); break; }
    }
    return out;
  }

  function build(items) {
    var P = [], vocabMap = {}, i, k;
    for (i = 0; i < items.length; i++) {
      var raw = items[i], skus = raw.s || [], tags = raw.g || [];
      var it = {
        raw: raw, rank: i,
        nt: norm(raw.t), ns: [], words: splitWords(raw.t), nv: norm(raw.v), ny: norm(raw.y), tags: [],
        dw: splitWords(raw.d), isKit: KIT_RE.test(raw.t || '')
      };
      for (k = 0; k < skus.length; k++) it.ns.push(norm(skus[k]));
      for (k = 0; k < tags.length; k++) it.tags.push(norm(tags[k]));
      for (k = 0; k < it.words.length; k++) if (it.words[k].length >= 4) vocabMap[it.words[k]] = 1;
      for (k = 0; k < it.dw.length; k++) if (it.dw[k].length >= 4) vocabMap[it.dw[k]] = 1;
      P.push(it);
    }
    var vocab = Object.keys(vocabMap);
    var N = P.length;

    function candidates(f) {
      var c = [f], s = stem(f);
      if (s !== f) c.push(s);
      if (SYN[f]) c = c.concat(SYN[f]);
      return uniq(c);
    }
    function bestScore(it, cands) {
      var best = 0;
      for (var j = 0; j < cands.length; j++) { var s = fragScore(it, cands[j]); if (s > best) best = s; }
      return best;
    }
    function emptyResult() {
      return { total: 0, partial: false, typo: [], facets: { vendor: {}, type: {}, available: { 'true': 0, 'false': 0 }, price: {}, f: {} }, items: [] };
    }
    function pick(it, score) {
      var r = it.raw;
      return { h: r.h, t: r.t, s: r.s || [], v: r.v, y: r.y, p: r.p, c: r.c, a: !!r.a, score: score };
    }

    function query(term, opt) {
      opt = opt || {};
      var frags = splitWords(term);
      if (!frags.length || frags.join('').length < 2) return emptyResult();
      var n = frags.length, cands = [], typo = [], j, m;
      for (j = 0; j < n; j++) cands.push(candidates(frags[j]));

      // scores[m][j] = best tier of product m for fragment j
      var scores = new Array(N);
      for (m = 0; m < N; m++) { scores[m] = new Array(n); for (j = 0; j < n; j++) scores[m][j] = bestScore(P[m], cands[j]); }

      // Typo fallback: a fragment (≥5 chars) with zero hits anywhere -> edit-distance-1 vocabulary words.
      for (j = 0; j < n; j++) {
        var hitAny = false;
        for (m = 0; m < N && !hitAny; m++) if (scores[m][j]) hitAny = true;
        if (hitAny || frags[j].length < 5) continue;
        var alts = [];
        for (k = 0; k < vocab.length && alts.length < 5; k++) if (lev1(frags[j], vocab[k])) alts.push(vocab[k]);
        if (!alts.length) continue;
        typo.push({ from: frags[j], to: alts[0] });
        for (m = 0; m < N; m++) scores[m][j] = bestScore(P[m], alts) * 0.9;
      }

      // IDF per fragment.
      var idf = new Array(n);
      for (j = 0; j < n; j++) { var df = 0; for (m = 0; m < N; m++) if (scores[m][j]) df++; idf[j] = Math.log(1 + N / (df || 1)); }

      var scored = [];
      for (m = 0; m < N; m++) {
        var hit = 0, wsum = 0, ssum = 0;
        for (j = 0; j < n; j++) if (scores[m][j]) { hit++; wsum += idf[j]; ssum += scores[m][j] * idf[j]; }
        if (hit) scored.push({ it: P[m], hit: hit, wsum: wsum, ssum: ssum });
      }
      var pool = [], partial = false;
      for (m = 0; m < scored.length; m++) if (scored[m].hit === n) pool.push(scored[m]);
      if (!pool.length && n >= 2) {
        var need = Math.ceil(n / 2);
        for (m = 0; m < scored.length; m++) if (scored[m].hit >= need) pool.push(scored[m]);
        partial = pool.length > 0;
      }
      if (!pool.length) return emptyResult();

      // Internal upgrade-price items belong only in explicit upgrade searches.
      var wantsUpgrade = /\bupgrades?\b/i.test(term);
      pool = pool.filter(function (x) { return wantsUpgrade || !/^(?:NVR|HDD|Storage|Camera)\s+Upgrade\b/i.test(x.it.raw.t || ''); });
      var wantsKit = WANTS_KIT_RE.test(term);
      pool.sort(function (a, b) {
        return (b.wsum - a.wsum) || (b.ssum - a.ssum) ||
          (!wantsKit ? ((a.it.isKit ? 1 : 0) - (b.it.isKit ? 1 : 0)) : 0) ||
          ((b.it.raw.a ? 1 : 0) - (a.it.raw.a ? 1 : 0)) ||
          (a.it.rank - b.it.rank);
      });

      // Facets on the full (unfiltered) pool. `f` holds the metafield facets
      // (resolution, nightvision, …) keyed exactly like the index; `price` uses
      // the same three buckets as the collection sidebar (cents).
      var facets = { vendor: {}, type: {}, available: { 'true': 0, 'false': 0 }, price: {}, f: {} };
      var fk, fv;
      for (m = 0; m < pool.length; m++) {
        var r = pool[m].it.raw, v = r.v || '', y = r.y || '';
        facets.vendor[v] = (facets.vendor[v] || 0) + 1;
        facets.type[y] = (facets.type[y] || 0) + 1;
        facets.available[r.a ? 'true' : 'false']++;
        var pb = priceBucket(r.p);
        facets.price[pb] = (facets.price[pb] || 0) + 1;
        if (r.f) for (fk in r.f) if (Object.prototype.hasOwnProperty.call(r.f, fk)) {
          if (!facets.f[fk]) facets.f[fk] = {};
          var labels = r.f[fk] || [];
          for (k = 0; k < labels.length; k++) { fv = labels[k]; if (fv) facets.f[fk][fv] = (facets.f[fk][fv] || 0) + 1; }
        }
      }

      // Filters: AND across groups, OR inside a group.
      var f = opt.filters || {}, out = [];
      for (m = 0; m < pool.length; m++) {
        var rr = pool[m].it.raw;
        if (f.vendor && f.vendor.length && f.vendor.indexOf(rr.v) === -1) continue;
        if (f.type && f.type.length && f.type.indexOf(rr.y) === -1) continue;
        if (f.inStock !== false && !rr.a) continue;
        if (f.price && f.price.length && f.price.indexOf(priceBucket(rr.p)) === -1) continue;
        if (f.priceMin != null && rr.p < f.priceMin) continue;
        if (f.priceMax != null && rr.p > f.priceMax) continue;
        if (f.f && !matchesFacets(rr.f || {}, f.f)) continue;
        out.push(pick(pool[m].it, pool[m].ssum));
      }

      // Sort (relevance keeps pool order).
      var sort = opt.sort || 'relevance';
      if (sort === 'price-asc') out.sort(function (a, b) { return a.p - b.p; });
      else if (sort === 'price-desc') out.sort(function (a, b) { return b.p - a.p; });
      else if (sort === 'title-asc') out.sort(function (a, b) { return a.t.localeCompare(b.t); });

      var offset = opt.offset || 0, limit = opt.limit == null ? 50 : opt.limit;
      return { total: out.length, partial: partial, typo: typo, facets: facets, items: out.slice(offset, offset + limit) };
    }

    return { query: query, size: N };
  }

  return { norm: norm, splitWords: splitWords, stem: stem, lev1: lev1, build: build, suggest: suggest, SYN: SYN, PRICE_BUCKETS: PRICE_BUCKETS, priceBucket: priceBucket };
});
